import {
    filterLearningOppsByStatePredicate,
  } from "@/components/BrowseFilter";
  import {
    LearningOpportunityFilterState,
  } from "@/utils/browseFilter";
  import {
    sortLearningOpportunitiesByStatus,
    BrowseLearningOpportunities,
  } from "@/server/backend-api";
export const SearchFunc = (learningOpps: BrowseLearningOpportunities[], searchQuery: string, filter: LearningOpportunityFilterState) => {
    const filteredBySearch = learningOpps.filter((learningOpp) => {
        const title = learningOpp.title;
        if (title === null) {
          return searchQuery !== "";
        }
        return title.toLowerCase().includes(searchQuery.toLowerCase());
      });
      const filteredLearningOpportunities = filteredBySearch.filter(
        (learningOpportunity) =>
          filterLearningOppsByStatePredicate(learningOpportunity, filter)
      );
      const sortedAndFilteredLearningOpps = sortLearningOpportunitiesByStatus(
        filteredLearningOpportunities
      );
      return sortedAndFilteredLearningOpps;
}
